<script setup>
import { useApiService } from '@/utils/useApiService';
import { onBeforeMount } from 'vue';

const {
    fetchWrapperForGet,
} = useApiService();

onBeforeMount(async () => {
    const data = await fetchWrapperForGet('api/AntiForgeryToken')
    if (data) {
        document.cookie = `X-CSRF-TOKEN=${data.antiForgeryToken}; path=/; secure; SameSite=Lax`;
    }

})



</script>

<template>
    <router-view />
</template>

<style scoped></style>
